import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20art%2C%20dramatic%20fantasy%20scene%20with%20mystical%20atmosphere%2C%20dark%20silhouette%20of%20a%20figure%20overlooking%20a%20glowing%20city%2C%20rich%20deep%20crimson%20and%20gold%20accents%2C%20ethereal%20lighting%2C%20artist%20colorful%20manhwa%20illustration%2C%20epic%20scale%2C%20cinematic%20composition%2C%20no%20text&width=1920&height=1080&seq=hero-bg-manhwa&orientation=landscape"
        alt="尾巴漫画 - 韩漫在线阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex items-end">
        <div className="w-full px-4 md:px-6 pb-16 md:pb-24">
          <div className="max-w-3xl">
            <span className="inline-block px-4 py-1.5 border border-background-50/30 rounded-full text-background-50 text-xs font-medium mb-6 backdrop-blur-sm">
              每日更新 · 高清无删减
            </span>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-background-50 leading-tight mb-4">
              发现好看的
              <span className="block font-serif italic font-normal text-primary-300">
                韩国漫画
              </span>
            </h1>
            <p className="text-background-50/80 text-sm md:text-base max-w-lg mb-8 leading-relaxed">
              尾巴漫画网专注韩漫在线免费阅读，高清画质、流畅下拉式阅读体验。
              覆盖恋爱、玄幻、动作、悬疑等多种类型，每日更新热门连载。
            </p>
            <div className="flex flex-col sm:flex-row items-start gap-3">
              <Link
                to="/category"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer"
              >
                立即阅读
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <Link
                to="/category?sort=ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-background-50/25 transition-all duration-200 cursor-pointer border border-background-50/20"
              >
                热门排行
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-fire-line"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 right-8 hidden lg:flex items-center gap-2">
        <span className="text-background-50/60 text-xs">向下滚动</span>
        <span className="w-5 h-5 flex items-center justify-center text-background-50/60">
          <i className="ri-arrow-down-line animate-bounce"></i>
        </span>
      </div>
    </section>
  );
}